import { utils } from "../utils";
import api from "../api";

class TranslatorService {
	constructor() {
		this.lang = $("html").attr("lang") || "ru";
		this.messages = {};
		this.translatorLoadingStatus = false;
	}

	get isLoaded() {
		return this.translatorLoadingStatus;
	}

	/**
	 * Получить все переводы
	 * @return {Promise}
	 */
	getLanguages() {
		return new Promise((resolve, reject) => {
			let messagesFromStorage = null;
			try {
				messagesFromStorage = utils.getObjectFromSessionStorage("messages");
			} catch (err) {
				console.log(err);
				alert(`Произошла ошибка переводчика!\n${err.message}`);
			}

			/* Если есть в сессии то возвращаем оттуда */
			if (messagesFromStorage && messagesFromStorage.main && messagesFromStorage.main.lang) {
				if (this.lang === messagesFromStorage.main.lang) {
					this.translatorLoadingStatus = true;
					return resolve((this.messages = messagesFromStorage));
				}
			}

			/* Иначе запрашиваем новые */
			return api.language.getAllDictionary(this.lang).then(res => {
				this.messages = res;
				utils.setObjectToSessionStorage("messages", this.messages);
				this.translatorLoadingStatus = true;
				return resolve(this.messages);
			});
		});
	}

	/**
	 * Получить перевод слова
	 * @param category {String}
	 * @param message {String}
	 * @param params {Object}
	 * @return {String}
	 */
	t(category, i18nKey, params = {}) {
		if (!this.messages[category] || !this.messages[category][i18nKey]) {
			return i18nKey;
		}

		let text = this.messages[category][i18nKey];

		return params ? Object.entries(params)
			.reduce((acc, [replaceable, value]) => {
				const regex = new RegExp(`{${replaceable}}`, "i");
				return acc.replace(regex, value);
			}, text)
			: text;
	}
}

export const translator = new TranslatorService();
